import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {TableCell, TableRow} from "../../../shadcn/components/ui/table";
import {GET_PROFILE_BY_ID} from "../../Membership/MembershipService";
import {GET_TEAM_DETAILS} from "../../Teams/TeamsService";
import {getDetailsFromInvitationType, getDetailsToInvitationType} from "../ProfilesTable/ProfilesTableRow";
import useGraphql from "../../../Hooks/useGraphql";
import useLog from "../../../Hooks/useLog";
import { toast } from "sonner";

const UserInvitationsTableRow = ({ data = {}, menuActions, lastElementRef}) => {
    const [fromDetails, setFromDetails] = useState('')
    const [toDetails, setToDetails] = useState('')
    const [itemDetails, setItemDetails] = useState('')
    const {axiosGraphQL} = useGraphql();
    const {errorLog} = useLog();

    useEffect(() => {
        getDetailsFromInvitationType(data.invitationType, data.fromId, setFromDetails, axiosGraphQL, errorLog)
        getDetailsToInvitationType(data.invitationToType, data.toId, setToDetails, axiosGraphQL, errorLog)
        if(data.context.itemType === 'profile') {
            axiosGraphQL({query: GET_PROFILE_BY_ID, variables: {ids: [data?.context?.itemId]}})
                .then((response) => {
                    const profile = response.data.data.profilesById[0];
                    setItemDetails(`${profile.firstName} ${profile.lastName}`)
                }).catch((error) => {
                    errorLog(error, "UserInvitationsTableRow", "useEffect", "GET_PROFILE_BY_ID");
                    toast.error(error.message);
                });
        } else if(data.context.itemType === 'team') {
            axiosGraphQL({
                query: GET_TEAM_DETAILS,
                variables: { teamIds: [data?.context?.itemId]},
            }).then((response) => {
                const teamDetails = response.data.data.teamDetails;
                setItemDetails(teamDetails?.name)
            }).catch((error) => {
                errorLog(error, "UserInvitationsTableRow", "useEffect", "GET_TEAM_DETAILS");
                toast.error(error.message);
            });
        }
    }, [])

  return (
        <TableRow>
            <TableCell role="rowheader" className="px-4 font-medium">{fromDetails}</TableCell>
            <TableCell className="px-4">{toDetails}</TableCell>
            <TableCell className="px-4">{itemDetails}</TableCell>
            <TableCell className="px-4">{data?.status}</TableCell>
            <TableCell className="px-4">{data?.invitationType}</TableCell>
        </TableRow>
  );
};

UserInvitationsTableRow.propTypes = {};

export default UserInvitationsTableRow;
